// extracted by mini-css-extract-plugin
module.exports = {"buttons":"CSVDownloadModal_buttons__98lcl","btn":"CSVDownloadModal_btn__1eK1F"};